<template>
  <v-card>
    <v-card-title>
      List Roles and Permissions
      <v-btn small icon @click="dataRefresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search"
    v-bind:rows-per-page-items="rowsPerPage">
      <template slot="items" slot-scope="props">
        <td class="layout px-0">
          <v-btn small icon :to="{name: 'roleEdit',
            params: { id: props.item.rowId}}">
            <v-icon right small color="grey">more_horiz</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-left">{{ props.item.roleId }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left" width="70%">{{ displayPermissions(props.item.permissions) }}</td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ error }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import RolePermissionService from '@/services/RolePermissionService'

  export default {
    data() {
      return {
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          20,
          30,
          {"text": "All", "value": -1}
        ],
        headers: [
          {
            text: 'Edit',
            align: 'left',
            sortable: false,
            value: null
          },
          { text: 'Role ID', align: 'left', value: 'roleId' },
          { text: 'Role Description', align: 'left', value: 'description' },
          { text: 'Permission Description', align: 'left', value: '' },
        ],
        error: '',
        items: [],
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.error = ''
        this.items = (await RolePermissionService.index()).data
      } catch (error) {
        this.error = this.handleError(error)
      }
    },
    methods: {
      async dataRefresh() {
        try {
          this.error = ''
          this.items = (await RolePermissionService.index()).data
        } catch (error) {
          this.error = this.handleError(error)
        }
      },
      displayPermissions(permissions) {
        if (permissions) {
          var permissionlist = []
          for (var i=0; i < permissions.length; i++) {
            if (permissions[i]) {
              permissionlist.push( permissions[i].permissionId + '. ' + permissions[i].description )
            }
          }
          if (permissionlist) {
            return permissionlist.join(' ')
          } else {
            return null
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SystemAdmin/RolePermission.vue